import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase, readableError } from '../../lib/supabase'
import { useSession } from '../../lib/session'
import { toSentenceCase } from '../../lib/format'
import { Shell } from '../../components/Shell'
import { Field, Sill } from '../../components/ui'

export default function ChurchSignup() {
  const { refresh, chooseChurch } = useSession()
  const nav = useNavigate()
  const [f, setF] = useState({ name: '', city: '', state: '', country: 'AU', denomination: '', staff_title: 'Administrator', contact_email: '' })
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })

  const create = async () => {
    setBusy(true); setErr(null)
    // RLS blocks self-inserting an approved admin membership, so founding a
    // church goes through this RPC, which does both atomically.
    const { data, error } = await supabase.rpc('create_church', {
      p_name: toSentenceCase(f.name), p_city: f.city ? toSentenceCase(f.city) : null, p_state: toSentenceCase(f.state) || null,
      p_country: f.country || 'AU', p_denomination: f.denomination ? toSentenceCase(f.denomination) : null,
      p_staff_title: toSentenceCase(f.staff_title) || 'Administrator',
      p_contact_email: f.contact_email.trim() || null,
    })
    setBusy(false)
    if (error) return setErr(readableError(error))
    chooseChurch(data)
    await refresh()
    nav('/admin/process')
  }

  return (
    <Shell back="/join" title="Back">
      <div className="eyebrow">Administrator</div>
      <h2 className="q">Set up your church.</h2>
      <p className="sub">You'll be the administrator — people and setup. Reviewing songs is a separate seat.</p>
      <Sill />

      <Field label="Church name"><input className="input" value={f.name} onChange={set('name')} /></Field>
      <Field label="City"><input className="input" value={f.city} onChange={set('city')} /></Field>
      <Field label="State"><input className="input" value={f.state} onChange={set('state')} /></Field>
      <Field label="Denomination (optional)">
        <input className="input" value={f.denomination} onChange={set('denomination')} />
      </Field>
      <Field label="Your job title">
        <input className="input" value={f.staff_title} onChange={set('staff_title')}
               placeholder="Executive Assistant" />
      </Field>

      {/* Deliberately the church's address, not the founder's. It is the only
          way to reach a church once the person who signed up has moved on —
          which is exactly when someone needs reaching. */}
      <Field label="Church email">
        <input className="input" type="email" value={f.contact_email}
               onChange={set('contact_email')} placeholder="office@yourchurch.org" />
      </Field>
      <p className="small" style={{ marginTop: -8 }}>
        A shared address the church keeps — an office or admin inbox, not a personal one.
        It's how we reach the church if whoever set this up moves on.
      </p>

      <button className="btn btn-primary"
              disabled={busy || !f.name.trim() || !f.contact_email.includes('@')}
              onClick={create}>
        {busy ? 'Creating…' : 'Create church'}
      </button>
      {err && <p className="err">{err}</p>}
    </Shell>
  )
}
